import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" style={{
    minHeight: '100svh'
  }} data-id="element-44">
      {/* Background image — mobile uses portrait image, desktop uses landscape */}
      <div className="absolute inset-0" data-id="element-45">
        <img src="https://cdn.magicpatterns.com/uploads/fuPQf4KUNXkTAqbmLasmba/mobile_hero.png" alt="Hogar de Revista — móvil sobre travertino" className="w-full h-full object-cover object-center md:hidden" data-id="element-46" />
        <img src="https://cdn.magicpatterns.com/uploads/vYnefDVa5PhWAUWojnGJJK/product_hero.png" alt="Hogar de Revista — laptop y tablet sobre mesa de mármol" className="hidden md:block w-full h-full object-cover object-center" data-id="element-47" />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C1C]/90 via-[#1C1C1C]/30 to-[#1C1C1C]/10" data-id="element-48"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-end px-5 md:px-16 pb-12 md:pb-20 pt-24 md:pt-0" style={{
      minHeight: '100svh'
    }} data-id="element-49">
        <div className="max-w-3xl" data-id="element-50">
          <span className="inline-block py-1 px-3 border border-[#C9A96E] text-[#C9A96E] text-xs tracking-[0.2em] uppercase mb-5 font-medium" data-id="element-51">
            Ingeniería Estética
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-serif text-white leading-[1.05] mb-4 tracking-tight" data-id="element-52">
            El Método{' '}
            <span className="italic text-[#C9A96E]" data-id="element-53">Perfect-Hang</span>
          </h1>

          <p className="text-sm md:text-xl text-white/80 font-light max-w-sm md:max-w-xl mb-8 leading-relaxed" data-id="element-54">
            No es costura. Es la ciencia detrás de la caída perfecta y el
            volumen exacto que ves en las tiendas de Beverly Hills.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3" data-id="element-55">
            <button onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} className="group bg-[#C9A96E] text-[#1C1C1C] px-7 py-4 text-base font-medium tracking-wide hover:bg-white transition-colors duration-300 flex items-center justify-center gap-2" data-id="element-56">
              Descubre el Método
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-57" />
            </button>
            <span className="text-xs text-white/60 italic font-serif text-center sm:text-left" data-id="element-58">
              Sin máquina industrial. Sin experiencia previa.
            </span>
          </div>
        </div>
      </div>
    </section>;
}